var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-icon"},[_c('img',{style:('width:'+ _vm.size + '; height:' + _vm.size),attrs:{"src":_vm.src},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }